import { IValidationParamsErrorPayload } from 'onboarding/types/request'

export class ValidationParamsError extends Error {
  protected readonly errorsPayload: IValidationParamsErrorPayload[]

  constructor(message: string, items: IValidationParamsErrorPayload[]) {
    super(message)
    this.errorsPayload = items
  }

  public getErrorsPayload() {
    return this.errorsPayload
  }

  public toObject() {
    return {
      message: this.message,
      errorsPayload: this.errorsPayload,
    }
  }
}
